import { ItRequisitionStatusCodes } from '@Enum/api/ItRequisitionStatusCodes';

const transformStatusStringToEnumString = (status: string): string => {
  const result = status.toUpperCase().split(' ');

  if (result.length > 1) {
    return result.join('_');
  }

  return result.join('');
};

const checkIsHideCancelForITReqStatus = (
  requestType: string,
  status: string
): boolean => {
  if (requestType === 'ITRequisition') {
    const enumKey = transformStatusStringToEnumString(status);
    const enumValue =
      ItRequisitionStatusCodes[
        enumKey as keyof typeof ItRequisitionStatusCodes
      ];

    return enumValue >= 8; // disable cancel for it request status higher or equal 8 TASK: 1754
  }
  return false;
};

export default checkIsHideCancelForITReqStatus;
